import React from "react";
import { useVsiAppContext} from "../../../stores/VsiApp";
import {useDataWithRoute, useTitleFromComponent} from "../../../utils/hooks";
import {VsiBubble, VsiH4} from "../../../styled/App.styled";
import Grid from "../../../components/Grid";
import {dateFormatter, numberFormatter, percentageBarFormatter} from "../../../utils/gridFormatters";
import {Card} from "reactstrap";


const colDefs = [
    {
        "field": "collection_date",
        "headerName": "Collection Date",
        "cellRenderer": dateFormatter,
        "enableRowGroup": true,
    },
    {
        "field": "pool_name",
        "headerName": "Pool",
        "enableRowGroup": true,
    },
    {
        "field": "device_name",
        "headerName": "Array Name",
        "enableRowGroup": true,
    },
    {
        "field": "pool_used",
        "headerName": "Pool Used",
        "cellRenderer": numberFormatter,
		aggFunc: "sum",
        "enableRowGroup": true,
    },
    {
        "field": "pool_free",
        "headerName": "Free",
        "cellRenderer": numberFormatter,
		aggFunc: "sum",
        "enableRowGroup": true,
    },
    {
        "field": "pool_total",
        "headerName": "Allocated",
        "cellRenderer": numberFormatter,
		aggFunc: "sum",
        "enableRowGroup": true,
    },
    {
        "field": "pool_pct_used",
        "headerName": "% Used",
        "cellRenderer": percentageBarFormatter,
		aggFunc: "overallAvgPct",
        "enableRowGroup": true,
    },
]

export default function BackupPoolSummary({title, context}) {
    useTitleFromComponent(`${context} / ${title}`);
    const { theme, client, periodId } = useVsiAppContext();


    let route = `/api/v6/report/backup_pool_summary_proc?client_id=${client.clientId}&period_id=${periodId}`;
    const [data, {isLoading}] = useDataWithRoute(route);

    return (
        <Card className={`report-card p-2 nav-card-${theme}`}>
            <VsiH4>Backup Pool Summary</VsiH4>
            <VsiBubble>
                <Grid
                    data={data.recordset}
                    columnDefs={colDefs}
                    isLoading={isLoading}
                />
            </VsiBubble>
        </Card>
    )
}
